/* Smart Business v9: make the existing volume form reachable on quote-only PDPs.
 * Runs before sb-volume-quote-v5.js. No submission, pricing or inventory changes.
 */
(function () {
  'use strict';
  if (window.sbVolumeQuoteAccessV9) return;
  window.sbVolumeQuoteAccessV9 = true;

  function prepare() {
    document.querySelectorAll('[data-sbv-root]').forEach(function (root) {
      var info = document.querySelector('.template-product .product__info-container');
      if (!info || !info.querySelector('.product-form__buttons .sb-product-quote')) return;
      var existing = info.querySelector('.sb-ob-vol a') || Array.prototype.find.call(
        info.querySelectorAll('.ishi-progress-content a[href*="whatsapp"]'),
        function (link) { return /volumen/i.test(link.textContent); }
      );
      if (existing) return;

      var buy = info.querySelector('.buy-btn-space');
      // A contact form must never be placed inside the product/cart form.
      if (!buy || buy.closest('form')) return;
      var row = info.querySelector('.sb-ob-actions');
      if (!row) {
        row = document.createElement('div');
        row.className = 'sb-ob-actions sbv-quote-only-actions';
        row.setAttribute('data-sbv-quote-access', '9');
        buy.insertAdjacentElement('afterend', row);
      }
      var item = document.createElement('div');
      item.className = 'sb-ob-action sb-ob-vol';
      var link = document.createElement('a');
      link.href = '#' + root.id;
      link.textContent = 'Cotiza por volumen';
      // The original form script binds this exact anchor, syncs SKU/quantity,
      // and opens the same approved form. Do not create another form or sender.
      item.appendChild(link);
      row.appendChild(item);
    });
  }

  prepare();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepare, { once: true, capture: true });
  }
  // Capture runs before the existing form's section-load initialization.
  document.addEventListener('shopify:section:load', prepare, true);
})();
